import React from 'react'
import { selectFontStyle } from '../../../../../CommonComponent/SelectFontStyle'
import config from '../../../../../config'
import { currencySymbolMapping } from '../../../../../CommonComponent/staticValues'

export default function PreviewLotSection({lot, index, auctionData}) {
    const currency = auctionData.currency || 'USD';
    const currencySymbol = currencySymbolMapping[currency] || '$';

    // Get the first lot image (featured or first in array)
    const getLotImage = () => {
        if (!lot.images || lot.images.length === 0) {
            return null;
        }
        if (Array.isArray(lot.images) && lot.images.length > 0) {
            const featured = lot.images.find(img => img.featured || img.feature) || lot.images[0];
            const imageUrl = typeof featured === 'string' ? featured : featured?.url;
            if (typeof imageUrl === 'string' && imageUrl !== '') {
                return imageUrl.startsWith('http') ? imageUrl : `${config.Storage.CDN}${imageUrl}`;
            }
        } else if (typeof lot.images === 'string' && lot.images !== '') {
            return lot.images.startsWith('http') ? lot.images : `${config.Storage.CDN}${lot.images}`;
        }
        return null;
    };

    const lotImage = getLotImage();

    const formatCurrency = (value) => {
        if (value === undefined || value === null || value === '') return `${currencySymbol}0`;
        return Number(value).toLocaleString(currency === 'INR' ? 'en-IN' : 'en-US', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
    };

    return (
        <div className="md:mt-20 sm:mt-10 mt-5 xl:w-1/4 md:w-1/3 sm:w-[50%] w-full px-5" >
            <div className={`w-full relative flex justify-center items-center px-5 h-[126px] overflow-hidden 
                ${!lotImage ? 'bg-[#E6E6E6]' : ''}`}>
                {lotImage ? (
                    <img 
                        src={lotImage} 
                        alt={lot.title || `Lot ${index + 1}`} 
                        loading="lazy" 
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <img src="/images/lot-list-img.png" alt="lot-list" loading="lazy" />
                )}
            </div>
            <p className="pt-3 text-[11px] sm:text-left text-center leading-normal 
                font-medium text-[#343434]" style={{fontFamily: selectFontStyle(auctionData.font['body_font']),
                color: auctionData.content_area['text_color']
            }}>
                {lot.lot_number || index + 1}. {lot.title1 || lot.title || 'Title of the lot goes here'}</p>
            <p className="text-[9px] pt-1 leading-normal font-medium sm:text-left text-center 
                text-[#52525A]" style={{fontFamily: selectFontStyle(auctionData.font['body_font']),
                color: auctionData.content_area['text_color']
            }}>
                {lot.title2 || lot.title_2 || 'Title 2 of the lot is here'}</p>
            <p className="pt-2 m-0 text-[8px] sm:text-left text-center leading-normal 
                font-medium text-[#717179]" style={{fontFamily: selectFontStyle(auctionData.font['body_font']),
                color: auctionData.content_area['text_color']
            }}>Estimate</p>
            <p className=" m-0 text-[11px] sm:text-left text-center leading-normal font-medium text-[#343434]"
                style={{fontFamily: selectFontStyle(auctionData.font['body_font']),
                    color: auctionData.content_area['text_color']
                }}>
                {lot.low_estimate !== undefined && lot.high_estimate !== undefined 
                    ? `${formatCurrency(lot.low_estimate)} - ${formatCurrency(lot.high_estimate)}`
                    : formatCurrency(0)}
            </p>
            <p className="pt-1 m-0 text-[8px] sm:text-left text-center leading-normal 
                font-medium text-[#717179]" style={{fontFamily: selectFontStyle(auctionData.font['body_font']),
                color: auctionData.content_area['text_color']
            }}>Starting Bid</p>
            <p className=" m-0 text-[11px] sm:text-left text-center leading-normal font-medium text-[#343434]"
                style={{fontFamily: selectFontStyle(auctionData.font['body_font']),
                    color: auctionData.content_area['text_color']
                }}>{formatCurrency(lot.starting_price)}</p>
            <div className="flex items-center rounded-md mt-2 w-full justify-center border border-[#A1A1A9] 
                cursor-pointer hover:bg-[#F4F4F5] transition-colors">
                <p className="pr-2 text-[9px] py-[5px] leading-normal font-medium text-[#52525A]"
                    style={{fontFamily: selectFontStyle(auctionData.font['body_font']),
                        color: auctionData.content_area['text_color']
                    }}>Select max bid</p>
                <img src="/images/dropdown-icon.png" alt="dropdown-icon" loading="lazy" />
            </div>
        </div>    
    )
}
